import {
  ViewerEventEnums
} from 'models'

export const statsOverviewEvents = [
  ViewerEventEnums.BLOB_TRIGGERED,
  ViewerEventEnums.PRODUCT_PAGE_OPENED,
  ViewerEventEnums.POSTER_CLICKED,
  ViewerEventEnums.VOV_CLICKED
]

export const statsOverviewExpensesEvents = [
  ViewerEventEnums.BLOB_TRIGGERED,
  ViewerEventEnums.BLOB_ATTACHED,
  ViewerEventEnums.BLOB_DETACHED,
  ViewerEventEnums.POSTER_ATTACHED,
  ViewerEventEnums.PRODUCT_PAGE_OPENED,
  ViewerEventEnums.ADD_TO_CART,
  ViewerEventEnums.POSTER_CLICKED,
  ViewerEventEnums.PURCHASE,
  ViewerEventEnums.VOV_CLICKED
]

export const statsOverviewExpensesEventsLabels = {
  [ViewerEventEnums.BLOB_TRIGGERED]: 'Blobs',
  [ViewerEventEnums.BLOB_ATTACHED]: 'Blob attached',
  [ViewerEventEnums.BLOB_DETACHED]: 'Blob detached',
  [ViewerEventEnums.POSTER_ATTACHED]: 'Poster attached',
  [ViewerEventEnums.PRODUCT_PAGE_OPENED]: 'Product pages',
  [ViewerEventEnums.ADD_TO_CART]: 'Added To Cart',
  [ViewerEventEnums.POSTER_CLICKED]: 'Posters',
  [ViewerEventEnums.PURCHASE]: 'Purchase fee',
  [ViewerEventEnums.VOV_CLICKED]: 'VOV'
}

export const statsOverviewInteractionEvents = [
  ViewerEventEnums.BLOB_TRIGGERED,
  ViewerEventEnums.BLOB_ATTACHED,
  ViewerEventEnums.BLOB_DETACHED,
  ViewerEventEnums.POSTER_ATTACHED,
  ViewerEventEnums.PRODUCT_PAGE_OPENED,
  ViewerEventEnums.POSTER_CLICKED,
  ViewerEventEnums.ADD_TO_CART,
  ViewerEventEnums.PURCHASE,
  ViewerEventEnums.VOV_CLICKED
]

export const statsOverviewInteractionEventsLabels = {
  [ViewerEventEnums.BLOB_TRIGGERED]: 'Blobs triggered',
  [ViewerEventEnums.BLOB_ATTACHED]: 'Blob Attached',
  [ViewerEventEnums.BLOB_DETACHED]: 'Blob detached',
  [ViewerEventEnums.POSTER_ATTACHED]: 'Poster attached',
  [ViewerEventEnums.PRODUCT_PAGE_OPENED]: 'Product pages opened',
  [ViewerEventEnums.POSTER_CLICKED]: 'Posters clicked',
  [ViewerEventEnums.ADD_TO_CART]: 'Added to cart',
  [ViewerEventEnums.PURCHASE]: 'Purchases',
  [ViewerEventEnums.VOV_CLICKED]: 'VoV clicked'
}
